import { InjectionToken } from '@angular/core';

export interface AppConfig {
  isAdmin: boolean;
  loginUrl?: string;
  afterLoginUrl?: string;
  appName: 'admin' | 'user' | 'web_calculator' | 'web_history_voting' | 'web_historical_token';
}

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');